import type { PageLayoutProps } from '@/components/layout/PageLayout';
import { PageLayout } from '@/components/layout/PageLayout';
import { withTitle } from '@gik/core/hocs/withTitle';
import { CompetitorsPage } from '@gik/marketing/pages/CompetitorsPage';

export default function CompetitorsPageComp() {
  return withTitle('Competitors', <CompetitorsPage />);
}

CompetitorsPageComp.getLayout = function getLayout(page: React.ReactElement, layoutProps: PageLayoutProps) {
  return <PageLayout {...layoutProps}>{page}</PageLayout>;
};
